<template>
  <div
    :class="[
      $style.base,
      $style[payment],
      {
        [$style.disabled]: disabled
      }
    ]"
  >
    <BaseSpinner
      v-if="loading"
      inline
    />
    <div
      v-else
      :class="$style.inner"
    >
      <div
        v-if="icon"
        :class="$style.icon"
      >
        <BaseIcon
          :name="icon"
          :color="payment === 'pos' && !disabled ? 'success' : 'default'"
        />
      </div>
      {{ $t(`global.payments.${payment}`, brandNamePay()) }}
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import type { IconName } from '@/components/base-icon/types';
import { brandNamePay } from '@/helpers/brand-name';

defineProps<{
  disabled: boolean;
  icon: IconName | undefined;
  loading: boolean;
  payment: string;
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  padding: $spacing;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background-color: var(--color-bg);
  height: 100%;

  &.disabled {
    opacity: 0.5;
  }

  &:not(.disabled) {
    cursor: pointer;

    @include hover {
      background-color: var(--color-highlight);
    }
  }
}

.icon {
  position: relative;
  top: 1px;

  .base.cash & {
    transform: rotate(-90deg);
  }
}

.inner {
  display: flex;
  align-items: center;
  gap: $spacing * 0.5;
  height: 100%;
}
</style>
